import { getAugmentedNamespace } from "./_commonjsHelpers.js";
import * as experimentCore_esm from './../_node_modules/@amplitude/experiment-core/dist/experiment-core.esm.js';
const require$$1 = /* @__PURE__ */ getAugmentedNamespace(experimentCore_esm);
export {
  require$$1 as default
};
//# sourceMappingURL=experiment-core.esm.js.map
